(function() {
  'use strict';

  function getSelectedValuesFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const selectedParam = params.get('selected');
    if (!selectedParam) return [];
    
    return selectedParam.split(',').filter(v => v.trim() !== '');
  }

  function scrollToProductSection() {
    const productSection = document.querySelector('product-info[id^="MainProduct"], product-info');
    if (productSection) {
      const header = document.querySelector('header, .header-wrapper');
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 20;
      
      const elementPosition = productSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      return true;
    }
    return false;
  }

  function preselectVariants() {
    const selectedValues = getSelectedValuesFromUrl();
    if (selectedValues.length === 0) {
      return;
    }

    setTimeout(function() {
      scrollToProductSection();
    }, 100);

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    setTimeout(function() {
      selectedValues.forEach(function(value, index) {
        setTimeout(function() {
          const radioInput = variantSelects.querySelector(`input[type="radio"][value="${value}"]`);
          if (radioInput && !radioInput.checked && !radioInput.classList.contains('disabled') && !radioInput.hasAttribute('disabled')) {
            radioInput.click();
            return;
          }

          const selects = variantSelects.querySelectorAll('select');
          let foundInSelect = false;
          selects.forEach(function(select) {
            const option = Array.from(select.options).find(opt => opt.value === value);
            if (option && !option.disabled && select.value !== value) {
              select.value = value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              foundInSelect = true;
            }
          });

          if (!foundInSelect) {
            const extraItemsContainer = document.querySelector('.product__extra-items');
            if (extraItemsContainer) {
              const checkbox = extraItemsContainer.querySelector(`input[type="checkbox"][value="${value}"]`);
              if (checkbox && !checkbox.checked && !checkbox.disabled) {
                checkbox.checked = true;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        }, index * 150);
      });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselectVariants);
  } else {
    preselectVariants();
  }

  setTimeout(preselectVariants, 500);
})();
